// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectAdd_container__3rZNl","active":"ProjectAdd_active__1VZ8t","button":"ProjectAdd_button__2St85","icon":"ProjectAdd_icon__1P4L4","name":"ProjectAdd_name__3tlXK"};